import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseForm from 'containers/Base/BaseForm';
import {
  initialState,
  generalSection,
  validationSchema,
  initialValues,
  detailedSection,
} from './options';
import staticText from 'static/text_display.json';
import { AssetInfo } from 'utils/constants/informationText';
import { transformAssetTypeData } from 'utils/DataTransform/Asset/Form/CreateAsset';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { getCompanyAssetCategories } from 'reducers/securityCompany';
import { actions as assetTypeActions } from 'containers/Pages/Assets/AssetTypes/Modules/dataGridTable';
import { getAssetTypeDetailsTransformed } from 'containers/Pages/Assets/AssetTypes/Selectors/assetTypeSelectors';

const AssetTypeForm = ({
  assetType,
  editMode,
  closeForm,
  createAssetType,
  updateAssetType,
  userAssignedDepartments = [],
  allowableCategories,
  // from embedded version of this form component
  embeddedForm,
  disablePresist,
  persistentStateName,
  embeddedAssetCategory,
  enableEmbeddedAssetCategory = true,
}) => {
  const create = assetType => {
    const value = transformAssetTypeData(assetType);
    createAssetType({
      assetType: value,
      ...(embeddedForm && { embeddedForm }),
    });
    if (embeddedForm) {
      closeForm();
    }
  };

  const edit = assetType => {
    const value = transformAssetTypeData(assetType);
    updateAssetType({ assetType: value });
  };
  return (
    <BaseForm
      imageRequired={false}
      edit={editMode}
      initialValues={
        editMode
          ? initialValues(assetType)
          : {
              ...initialState,
              category: embeddedAssetCategory
                ? embeddedAssetCategory
                : initialState.category,
            }
      }
      formTitle={
        editMode
          ? staticText.managerial_view.asset_type.edit_default
          : staticText.managerial_view.asset_type.create
      }
      saveHoverText={
        editMode
          ? translatedKeyValueText('update_value_title', {
              value: assetType.generalInfo.name.value,
            })
          : staticText.managerial_view.asset_type.create
      }
      closeForm={closeForm}
      generalSection={generalSection({
        allowableCategories,
        userAssignedDepartments,
        enableEmbeddedAssetCategory,
      })}
      detailedSection={detailedSection()}
      validationSchema={validationSchema}
      onSubmit={editMode ? edit : create}
      hoverText={editMode ? assetType.generalInfo.name.value : ''}
      note={AssetInfo.note}
      disablePresist={disablePresist}
      persistentStateName={persistentStateName}
    />
  );
};

AssetTypeForm.propTypes = {
  assetType: PropTypes.object,
  editMode: PropTypes.bool,
  embeddedForm: PropTypes.bool,
  enableEmbeddedAssetCategory: PropTypes.bool,
  disablePresist: PropTypes.bool,
  closeForm: PropTypes.func.isRequired,
  createAssetType: PropTypes.func,
  updateAssetType: PropTypes.func,
  userAssignedDepartments: PropTypes.array,
  allowableCategories: PropTypes.array,
  persistentStateName: PropTypes.string,
  embeddedAssetCategory: PropTypes.string,
};

const mapStateToProps = state => ({
  assetType: getAssetTypeDetailsTransformed(state),
  allowableCategories: getCompanyAssetCategories(state),
});

const mapDispatchToProps = dispatch => ({
  createAssetType: ({ assetType, embeddedForm }) =>
    dispatch(assetTypeActions.createRowEntry({ assetType, embeddedForm })),
  updateAssetType: ({ assetType }) =>
    dispatch(assetTypeActions.updateRowEntry({ assetType })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetTypeForm);
